// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__fTKzz","text":"SelectPayment_text__4t3Mh","title":"SelectPayment_title__39BeM","btn":"SelectPayment_btn__1yw79"};